import { ServiceOrderStatus } from "services/serviceOrders/restModels";

export const PAGE_SIZE = 20;

export const ORDER_TYPE_LABELS: Record<"Card" | "Invoice", string> = {
    Card: "Карта",
    Invoice: "Счёт",
};

export const ORDER_STATUS_LABELS: Record<ServiceOrderStatus, string> = {
    New: "Не оплачен",
    Paid: "Оплачен",
    Cancelled: "Отменён",
    Error: "Ошибка",
};

export const ORDER_STATUS_TONES: Record<ServiceOrderStatus, "success" | "warning" | "danger"> = {
    New: "warning",
    Paid: "success",
    Cancelled: "warning",
    Error: "danger",
};
